<template>
  <div
      class="warehouse-order-article"
      :class="{ '-done': isDone, '-deleted': isDeleted, '-is-complete': isComplete }"
  >
    <div class="warehouse-order-article_description article-row">
      <div class="image">
        <ArticleDetailDialog :article="article">
          <template #customButton="{on, attrs}">
            <ArticleImage :article="article" v-on="on"/>
          </template>
        </ArticleDetailDialog>

      </div>
      <div class="text">
        <ArticleDetailDialog :article="article">
          <template #customButton="{on, attrs}">
            <ArticleCaption :article="article" v-on="on"/>
          </template>
        </ArticleDetailDialog>

      </div>
    </div>

    <div class="warehouse-order-article_unit article-row" :data-mobile-label="$t('sl.warehouse.headers.unit')">
      {{ article.unit }}
    </div>

    <v-tooltip bottom nudge-top="38">
      <template v-slot:activator="{ on, attrs }">
        <div class="warehouse-order-article_demand article-row" :data-mobile-label="$t('sl.warehouse.headers.demand')"
             v-bind="attrs"
             v-on="on"
        >
          <div>
          <span>
            {{ totalDemand }} / {{ totalPickedBefore }}
          </span>
          </div>
        </div>
      </template>
      <span>{{ totalDemand }} bestellt / {{ totalPickedBefore }} geliefert</span>
    </v-tooltip>

    <v-tooltip bottom nudge-top="38">
      <template v-slot:activator="{ on, attrs }">
        <div class="warehouse-order-article_due article-row" :data-mobile-label="$t('sl.warehouse.headers.due')"
             v-bind="attrs"
             v-on="on"
        >
          <div>
          <span :class="totalPicked > 0? 'text--primary': ''">
            {{ totalDue }}
          </span>
          </div>
        </div>
      </template>
      <span>{{ totalDue }} Offen</span>
    </v-tooltip>

    <div class="warehouse-order-article_spacer article-row">

    </div>


    <div class="warehouse-order-article_picked article-row" :data-mobile-label="$t('sl.warehouse.headers.picked')">
      <div v-if="isComplete">
        <template v-if="isDeleted">
          <span v-if="totalPicked > 0">{{ totalPicked }}</span>
        </template>
        <template v-else>
          {{ totalDemand }}
        </template>
      </div>
      <template v-else-if="!isDone">
        <v-text-field
            v-if="editable"
            class="float-right number-input primary-input-color"
            type="number"
            min="0"
            :max="totalDemand - totalPickedBefore"
            light
            autocomplete="off"
            style="width: 70px;margin-right: -10px;"
            :disabled="disabled || isComplete || isUpdating"
        />
        <div v-else :class="{ 'text--primary': totalPicked > 0 }">
          {{ totalPicked }}
        </div>
      </template>
    </div>

    <div class="warehouse-order-article_completed article-row"
         :data-mobile-label="$t('sl.warehouse.headers.completed')">
      <template v-if="isDone || isComplete">
        <div
            v-if="!isDeleted || (totalDemand - totalPicked === 0)"
            class="isDone pr-3 icon-haekchen font-weight-bold"
        ></div>
      </template>
      <div v-else-if="isDeleted"></div>
      <v-checkbox
          v-else-if="editable"
          :disabled="disabled || isUpdating"
      />
      <v-switch
          v-else
          v-model="completeArticle"
          :disabled="disabled || isComplete || isUpdating"
          inset
      />
    </div>

    <div class="warehouse-order-article_delete article-row" :data-mobile-label="$t('sl.warehouse.headers.delete')">
      <template v-if="!isDone && !isComplete">

        <ConfirmDialog
            title="Arikel entfernen"
            @confirm="deleteArticle"
        >
          <template #button>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="!isDeleted"
                    icon
                    class="delete-btn"
                    :disabled="disabled || isComplete || isUpdating"
                    v-bind="attrs"
                    v-on="on"
                >
                  <span class="icon-loeschen hover-link"></span>
                </v-btn>
              </template>
              <span>(Rest-) Menge nicht lieferbar</span>
            </v-tooltip>
          </template>
          Möchten Sie <span class="text--primary">{{ article.artikelNrLAG }} - {{ article.name }}</span> wirklich
          entfernen?
        </ConfirmDialog>


        <!--        <v-btn-->
        <!--            v-else-->
        <!--            icon-->
        <!--            :disabled="isUpdating"-->
        <!--            @click="restoreArticle"-->
        <!--        >-->
        <!--          <span class="icon-neu-laden hover-link"></span>-->
        <!--        </v-btn>-->
      </template>
    </div>
  </div>
</template>

<script>
import ArticleImage from "@/components/SmartLogistics/Article/ArticleImage.vue";
import ArticleCaption from "@/components/SmartLogistics/Article/ArticleCaption.vue";
import {internalOrderMixin} from "@/mixins/SmartLogistics/ModelC/internalOrder";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import {del} from "vue";
import is from "vue2-datepicker/locale/es/is";
import ArticleDetailDialog from "@/components/SmartLogistics/Article/ArticleDetailDialog.vue";
import {mapGetters} from "vuex";
import {completeItemsMixin} from "@/mixins/SmartLogistics/ModelC/completeItems";
import QuantityInput from "@/components/shared/QuantityInput.vue";

export default {
  name: 'OrderArticle',
  components: {QuantityInput, ArticleDetailDialog, ConfirmDialog, ArticleCaption, ArticleImage},
  mixins: [internalOrderMixin, completeItemsMixin],

  props: {
    article: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isComplete: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      planModel: 'smartLogisticSettings/planModel'
    }),
    hasNoPartialDelivery() {
      return this.order.status === 'new'
    },

    /**
     *
     * @returns {*}
     */
    allPicks() {
      return this.articlePicks(this.article.internalID)
    },

    /**
     *
     * @returns {number}
     */
    totalDemand() {
      let total = 0

      this.allPicks.forEach(item => {
        total += item.orderedQuantity
      })

      return total
    },

    /**
     *
     * @returns {number}
     */
    totalPicked() {
      let total = 0

      this.allPicks.forEach(item => {
        total += +item.quantity
      })

      return total
    },

    /**
     *
     * @returns {number}
     */
    totalDue() {
      let total = 0

      this.allPicks.forEach(item => {
        total += +item.deliveredBefore
        total += item.quantity
      })

      return this.totalDemand - total
    },

    /**
     *
     * @returns {number}
     */
    totalPickedBefore() {
      let total = 0

      this.allPicks.forEach(item => {
        total += +item.deliveredBefore
      })

      return total
    },

    isDone() {
      return this.totalPickedBefore === this.totalDemand
    },

    isDeleted() {
      return !this.allPicks.filter(i => !!!i.deleted).length > 0
    },

    /**
     *
     */
    completeArticle: {
      get() {
        let isComplete = true

        if (this.isComplete) return true

        this.allPicks.forEach(item => {
          if (item.orderedQuantity > item.deliveredBefore + item.quantity) {
            isComplete = false
          }
        })

        return isComplete
      },
      set(value) {
        if (value) {
          this.completeItems(this.allPicks)
        } else {
          this.resetItems(this.allPicks)
        }
      }
    }
  },

  methods: {
    /**
     *
     */
    deleteArticle() {
      const batch = []

      this.allPicks.forEach(item => {
        batch.push({
          artikelNrLAG: item.artikelNrLAG,
          ownerType: item.ownerType,
          ownerId: item.ownerId,
          quantity: 0,
          deleted: true
        })
      })

      this.$store.dispatch('smartLogisticWarehouse/deleteItemBatch', {
        partialDeliveryId: this.currentlyOpenPartialDelivery.id,
        batch: batch
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.image, .text > div {
  cursor: pointer;
}
.delete-btn {
  &:not(:hover) {
    .icon-loeschen {
      color: rgba(0, 0, 0, 0.87);
    }
  }

}
</style>
